/**
 * DOM helpers. Text is set with text nodes; attributes with setAttribute.
 * Event keys are `onClick` style and become addEventListener calls.
 */

function isSvgTag(tag) {
  return tag === 'svg' || tag === 'path' || tag === 'rect' || tag === 'circle' || tag === 'line';
}

function applyAttrs(node, attrs) {
  for (const [key, value] of Object.entries(attrs)) {
    if (value == null || value === false) continue;
    if (key === 'class' || key === 'className') {
      node.setAttribute('class', String(value));
      continue;
    }
    if (/^on[A-Z]/.test(key) && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value);
      continue;
    }
    node.setAttribute(key, value === true ? '' : String(value));
  }
}

function append(node, child) {
  if (child == null || child === false) return;
  if (Array.isArray(child)) {
    for (const item of child) append(node, item);
    return;
  }
  if (child instanceof Node) node.append(child);
  else node.append(document.createTextNode(String(child)));
}

/**
 * @param {string} tag
 * @param {Record<string, unknown>} [attrs]
 * @param {...unknown} children
 */
export function el(tag, attrs, ...children) {
  const node = isSvgTag(tag)
    ? document.createElementNS('http://www.w3.org/2000/svg', tag)
    : document.createElement(tag);
  applyAttrs(node, attrs || {});
  for (const child of children) append(node, child);
  return node;
}

/** @param {ParentNode} node */
export function clear(node) {
  node.replaceChildren();
}

/** @param {unknown} value */
export function text(value) {
  return document.createTextNode(value == null ? '' : String(value));
}
